(function($) {
    $(window).on('load', function () {

       // get all sliders, we need to loop them due to different settings + nav
        var swipers = document.querySelectorAll('.swiper:not(.control):not(.mobile)');
        swipers.forEach(function(el,index){
            var closestSection = el.closest('section');
            var controls = closestSection.querySelector('.control');

            // slider settings
            var options = {
                speed: 800,
                loop: true,
                autoplay: false,
               
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        allowTouchMove: true,
                    },
                    620: {
                        slidesPerView: 2,
                        allowTouchMove: true,
                    },
                    826: {
                        slidesPerView: 3,
                        allowTouchMove: false,
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                thumbs:{}
                // ,
                // on: {
                //     init: function() {
                //         if( window.lazyload != undefined ) {
                //             window.lazyload.update();
                //         }
                //     }
                // }
            };

            if(el.classList.contains('testimonialSlide')){
                options.autoplay = true;
                options.spaceBetween = 30;
                options.navigation.nextEl = ".review-button-next";
                options.navigation.prevEl = ".review-button-prev";
                options.breakpoints = {
                    640: {
                        slidesPerView: 1,
                    }
                    ,
                    992: {
                        slidesPerView: 2,
                    }
                }
            } 

            // init slider
            new Swiper(el, options);
        });
    })

    // mobile sliders, like logo rows etc
    // need to loop in order to get the slide count
    var resizeTimer, mobileSwiperSlider = [], mobileSwiperCount;
    $(window).on('resize load', function () {
        clearTimeout(resizeTimer);
        mobileSwiperSlider.forEach( function(slider, index) {
            if (typeof(slider) !== "undefined" ) {
                slider.destroy();
            }
        });

        resizeTimer = setTimeout(function () {
            
            // only initialise the slider if it is mobile size for mobile sliders
            mobile = window.matchMedia('(min-width: 0px) and (max-width: 992px)');

            if(mobile.matches) {
                mobileSwiperCount = 0;
                var mobileSwipers = document.querySelectorAll('.swiper.mobile');

                mobileSwipers.forEach(function(el,index){
                    
                    var slideCount = el.querySelectorAll('.swiper-slide').length;
        
                    var options = {
                        speed:600,
                        slidesPerView: 1,
                        watchOverflow: true,
                        loop: true,
                        simulateTouch: false,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: true,
                        },
                        pagination:{
                            el: '.swiper-pagination',
                            type: 'bullets',
                            clickable: true
                        },
                        breakpoints: {
                            640 : {
                                slidesPerView: 2
                            },
                            992: {
                                slidesPerView: slideCount,
                                loop: false,
                            }
                        }
                    };
        
                    // init slider
                    mobileSwiperSlider[mobileSwiperCount] = new Swiper(el, options);
                    mobileSwiperCount++;
                });
            }
            
        }, 500);
    })

    // Load More Gallery eature
    var hiddenSlides = $('.extended-gallery .swiper-slide.extra-slide');
    if(!hiddenSlides.length) {
        $('.load-more-gallery').hide();
    }
    $(document).on('click', '.extended-gallery .load-more-gallery', function (event) {
        hiddenSlides = $('.extended-gallery .swiper-slide.extra-slide');
        if(hiddenSlides.length <= 3) {
            $(this).hide();
        } else {
            for(var i = 0 ; i < 3 ; i++) {
                var slide = hiddenSlides[i];
                $(slide).removeClass('extra-slide');
                $(slide).fadeIn(500);
            }
        }
    })

})( jQuery );